import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Wind, Award, ShieldCheck, Rocket, Radio, MapPin, Palmtree, Music, Coffee, Package } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function WingFoilPage() {
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-610">
      <Navigation data-id="element-611" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-612">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-613" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg" alt="Wing Foil Activity" className="w-full h-full object-cover" style={{
        objectPosition: '60% 38%',
        transform: 'scale(2.0)'
      }} data-id="element-614" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-615">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-616">
            Wing Foil
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-617">
            לעוף מעל המים - הדור הבא של גלישה
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-618">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-619">
          <div data-id="element-620">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-621">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-622">
              ה-Wing Foil הוא הספורט הימי החדשני ביותר שכבש את העולם. הוא משלב
              כנף (Wing) המוחזקת ביד וגלשן עם סנפיר (Foil) המאפשר ריחוף מעל
              המים. התחושה היא של שקט מוחלט ומהירות, כמעט ללא חיכוך עם המים.
              הכנרת, עם הרוחות היציבות שלה בשעות הצהריים, היא המקום המושלם ללמוד
              ולהתקדם בספורט זה.
            </p>

            {/* Perfect Spot Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cyan-50 to-teal-50 border border-cyan-100 rounded-2xl p-6 mb-8" data-id="element-623">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-624">
                <Wind className="w-7 h-7 text-cyan-600" data-id="element-625" />
                חוף מושלם לגלישת Wing
              </h3>
              <div className="space-y-3 text-gray-700" data-id="element-626">
                <p className="flex items-start gap-2" data-id="element-627">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-628" />
                  <span data-id="element-629">
                    <strong data-id="element-630">רוח צד (Side Shore)</strong> - תנאי רוח אידיאליים
                    לגלישה בטוחה
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-631">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-632" />
                  <span data-id="element-633">
                    <strong data-id="element-634">רוח יציבה כמעט כל יום</strong> במשך העונה
                    (אפריל-אוקטובר)
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-635">
                  <MapPin className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-636" />
                  <span data-id="element-637">
                    <strong data-id="element-638">חניה קרובה למים</strong> - נוחות מקסימלית
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-639">
                  <Palmtree className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-640" />
                  <span data-id="element-641">
                    <strong data-id="element-642">מדשאות</strong> לנוחות והכנת ציוד
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-643">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-644" />
                  <span data-id="element-645">
                    <strong data-id="element-646">מתקן לטליית ווינגים וקומפרסור</strong>
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-647">
                  <Music className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-648" />
                  <span data-id="element-649">
                    <strong data-id="element-650">מוזיקה ופינת קפה</strong> - אווירה מושלמת
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-651">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-652" />
                  <span data-id="element-653">
                    <strong data-id="element-654">אחסון ציוד</strong> - ניתן לאחסן את הציוד שלכם במקום
                  </span>
                </p>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-655">
              יתרונות ה-Wing Foil
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-656">
              {['ציוד קל ונייד שקל להכין לפעילות', 'בטיחותי יותר מסוגי גלישות אחרים', 'עקומת למידה מהירה יחסית', 'תחושת ריחוף ייחודית וממכרת'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-657">
                  <div className="bg-cyan-100 p-1 rounded-full" data-id="element-658">
                    <Rocket className="w-4 h-4 text-cyan-600" data-id="element-659" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-660">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-661">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-662">
              <div className="flex gap-4" data-id="element-663">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-664">
                  <ShieldCheck className="w-6 h-6 text-cyan-500" data-id="element-665" />
                </div>
                <div data-id="element-666">
                  <h4 className="font-bold text-lg mb-1" data-id="element-667">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-668">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד גולשים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-669">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-670">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-671" />
                </div>
                <div data-id="element-672">
                  <h4 className="font-bold text-lg mb-1" data-id="element-673">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-674">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-675">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-676">
                  <Award className="w-6 h-6 text-cyan-500" data-id="element-677" />
                </div>
                <div data-id="element-678">
                  <h4 className="font-bold text-lg mb-1" data-id="element-679">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-680">
                    הצטרפו לקהילת גולשים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-681">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-682">
                  <Radio className="w-6 h-6 text-cyan-500" data-id="element-683" />
                </div>
                <div data-id="element-684">
                  <h4 className="font-bold text-lg mb-1" data-id="element-685">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-686">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-687">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-688">
                  <Package className="w-6 h-6 text-cyan-500" data-id="element-689" />
                </div>
                <div data-id="element-690">
                  <h4 className="font-bold text-lg mb-1" data-id="element-691">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-692">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-693">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-694">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-695" />
                </div>
                <div data-id="element-696">
                  <h4 className="font-bold text-lg mb-1" data-id="element-697">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-698">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-699">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-700">
                רוצה להתחיל לעוף!
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ContactSection data-id="element-701" />
      <Footer data-id="element-702" />
    </div>;
}